import React from 'react';
import { View, Text } from 'react-native';
import { useAdminThemeContext } from '../../contexts/AdminThemeContext';

export function AdminPageShell({ title, subtitle, children, fullWidth = false }) {
  const { styles: adminStyles } = useAdminThemeContext();

  return (
    <View style={[adminStyles.pageShell, fullWidth && adminStyles.pageShellFullWidth]}>
      {title ? <Text style={adminStyles.pageTitle}>{title}</Text> : null}
      {subtitle ? <Text style={adminStyles.pageSubtitle}>{subtitle}</Text> : null}
      {children}
    </View>
  );
}
